<script setup lang="ts">
/** [#e03fdbc2] Заявка с лендинга: один номер телефона. */
import { ref } from 'vue';
import { Check, Send } from 'lucide-vue-next';
import { TELEGRAM_URL } from '@/seo/site';
import { trackGoal } from './metrika';
import { usePublicPage } from './usePublicPage';

defineProps<{ title?: string; sub?: string; button?: string }>();

const { copy, more, to } = usePublicPage();
const phone = ref('');
const submitting = ref(false);
const sent = ref(false);
const error = ref<string | null>(null);

async function submit(): Promise<void> {
  if (!phone.value.trim()) return;
  submitting.value = true;
  error.value = null;
  try {
    const base = import.meta.env.DEV ? '/api' : (import.meta.env.VITE_API_URL ?? '');
    const res = await fetch(`${base}/landing/contact`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ phone: phone.value.trim() }),
    });
    if (!res.ok) throw new Error(String(res.status));
    sent.value = true;
    trackGoal('form_sent');
  } catch {
    error.value = copy.value.contact.error;
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <section id="contact" class="lp-section lp-wrap">
    <div class="lp-cta">
      <h2>{{ title ?? copy.contact.title }}</h2>
      <p>{{ sub ?? copy.contact.sub }}</p>
      <p v-if="sent" class="lp-sent"><Check :size="18" />{{ copy.contact.sent }}</p>
      <form v-else class="lp-form" @submit.prevent="submit">
        <input v-model="phone" class="ym-disable-keys ym-hide-content" type="tel" autocomplete="tel" required :placeholder="copy.contact.placeholder" :aria-label="copy.contact.placeholder" />
        <button type="submit" class="lp-btn lp-btn--primary" :disabled="submitting">
          {{ submitting ? copy.contact.sending : (button ?? copy.contact.submit) }}
        </button>
      </form>
      <p v-if="error" class="lp-error" role="alert">{{ error }}</p>
      <small>{{ more.privacy.consent }} <RouterLink :to="to('/privacy')" class="lp-consent">{{ more.privacy.title }}</RouterLink></small>
      <a :href="TELEGRAM_URL" class="lp-btn lp-btn--tg" rel="noopener"><Send :size="17" />{{ copy.contact.telegram }}</a>
    </div>
  </section>
</template>
